import store from "../index";
import { fetchGet } from "../api/fetch";
import { setUser } from "../actions/users";
import { size, filter } from "lodash";

export const getUser = async (id) => {
  let currentUsers = store.getState().users;

  // Return the values from store if exists
  if (currentUsers[id]) {
    return currentUsers[id];
  }

  // Fetch the values
  try {
    let user = await fetchGet(`users/${id}`);
    store.dispatch(setUser(id, user));
    return user;
  } catch (e) {
    console.log(e);
  }
};

export const isAllowed = (permissions, code) => {
  return size(filter(permissions, (p) => p.code === code)) > 0;
};

// export const isAssignedSiteRequired = (roles) => {
//   return (
//     size(
//       filter(roles, (r) => includes(toLower(get(r, ["name_en"])), "admin"))
//     ) > 0
//   );
// };
